export enum UserStatus {
  Active = 1,
  Inactive = 2,
  Pending = 3,
}

export const UserStatusLabels: Record<UserStatus, string> = {
  [UserStatus.Active]: 'Active',
  [UserStatus.Inactive]: 'Inactive',
  [UserStatus.Pending]: 'Pending',
};
